import { NavLink, Outlet, useLocation, useNavigate } from 'react-router'

import { useTranslate } from '@/shared/i18n'
import type { TranslationKey } from '@/shared/i18n'
import { useBackButton, useIsMainButtonVisible } from '@/shared/telegram'

import { routes } from './routes'
import './layout.css'

const tabs: { to: string; label: TranslationKey; icon: string }[] = [
  { to: routes.dashboard, label: 'nav.home', icon: '◎' },
  { to: routes.tasks, label: 'nav.tasks', icon: '✓' },
  { to: routes.documents, label: 'nav.documents', icon: '📄' },
  { to: routes.timeline, label: 'nav.timeline', icon: '⏱' },
  { to: routes.settings, label: 'nav.more', icon: '⋯' },
]

export function Layout() {
  const t = useTranslate()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const isTab = tabs.some((tab) => tab.to === pathname)
  const actionShown = useIsMainButtonVisible()

  useBackButton(isTab ? undefined : () => void navigate(-1))

  return (
    <div className="layout">
      <main className={actionShown ? 'layout__body layout__body--flush' : 'layout__body'}>
        <Outlet />
      </main>

      <nav className="tabs" aria-label={t('app.name')} hidden={actionShown}>
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.to === routes.dashboard}
            className={({ isActive }) => (isActive ? 'tabs__tab tabs__tab--active' : 'tabs__tab')}
          >
            <span className="tabs__icon" aria-hidden="true">
              {tab.icon}
            </span>
            {t(tab.label)}
          </NavLink>
        ))}
      </nav>
    </div>
  )
}
